import React, { createContext, useEffect } from "react";
import { useSearchParams } from "next/navigation";

// Create a new context
const Plausible = createContext();
const UTM_LS_KEY = "_utm_";
// Create a component that will provide the context
function PlausibleProvider({ children }) {

  const searchParams = useSearchParams();


  // Populate UTM in localStorage.
  const updateUTMParams = () => {
    const utmSource = searchParams.get("utm_source");
    const utmMedium = searchParams.get("utm_medium");
    const utmCampaign = searchParams.get("utm_campaign");
    const utmTerm = searchParams.get("utm_term");
    const utmContent = searchParams.get("utm_content");

    let utmParams = {};

    if (utmSource) {
      utmParams["utm_source"] = utmSource;
    }
    if (utmMedium) {
      utmParams["utm_medium"] = utmMedium;
    }
    if (utmCampaign) {
      utmParams["utm_campaign"] = utmCampaign;
    }
    if (utmTerm) {
      utmParams["utm_term"] = utmTerm;
    }
    if (utmContent) {
      utmParams["utm_content"] = utmContent;
    }

    // console.log("utmParams", Object.keys( utmParams ).length , utmParams);
    if ( Object.keys( utmParams ).length > 0 ) {
      window?.localStorage && window?.localStorage.setItem(UTM_LS_KEY, JSON.stringify(utmParams) );
    }
  };

  useEffect(() => {
    window.plausible = window.plausible || function () { (window.plausible.q = window.plausible.q || []).push(arguments) }
    updateUTMParams();
  }, []);

  const plausibleEvent = (customEventName, extraProps = {}) => {
    updateUTMParams();
    // Plausible Event
    const utmParams = readUtmFromLocalStorage();
    const plausible = window?.plausible;
    if (plausible && customEventName) {
      const finalProps = {...utmParams, ...extraProps};
      // console.log("--------- Fire Event -----------");
      // console.log("utmParams", utmParams);
      // console.log("customEventName", customEventName);
      // console.log("props", finalProps);
      plausible(customEventName, {props: finalProps});
    }
  }

  const getUtmParamsFromLocalStorage = () => {
    updateUTMParams();
    return readUtmFromLocalStorage();
  }
  
  const readUtmFromLocalStorage = () => {
    const utmParamsStr =  window?.localStorage.getItem( UTM_LS_KEY ) || "{}";
    try {
      return JSON.parse( utmParamsStr );
    } catch(e) {
      return {};
    }
  };
  

  // Use the Provider component to wrap the children
  return (
    <Plausible.Provider value={{ plausibleEvent, getUtmParamsFromLocalStorage }}>
      {children}
    </Plausible.Provider>
  );
}

export { Plausible, PlausibleProvider };
